<template>
  <flickity ref="flickity" :options="flickityOptions" class="flickity-container">
    <slot></slot>
  </flickity>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  name: 'AutoFlickity',
  components: { Flickity },
  data () {
    return {
      tickerSpeed: 0.4,
      playing: false,
      raf: null,
      flickityOptions: {
        wrapAround: true,
        dots: false,
        prevNextButtons: false,
        autoPlay: false,
        initialIndex: 1,
        pauseAutoPlayOnHover: false,
        accessibility: false
        // selectedAttraction: 0.01,
        // friction: 0.15
      }
    }
  },
  watch: {
    'mobile': 'handlePlayType'
  },
  computed: {
    mobile () {
      return this.$store.state.mobile
    },
  },
  mounted () {
    if (this.$refs.flickity) {
      this.handlePlayType()
    }
  },
  beforeDestroy () {
    if (this.$refs.flickity) {
      this.pause()
    }
  },
  methods: {
    play () {
      if (window.innerWidth <= 1000) return
      if (this.$refs.flickity && !this.playing) {
        this.playing = true
        this.frame()
      }
    },
    pause () {
      if (this.$refs.flickity && this.raf) {
        window.cancelAnimationFrame(this.raf)
        this.raf = undefined
        this.playing = false
      }
    },
    frame () {
      if (this.$refs.flickity) {
        this.$refs.flickity.$flickity.x = this.$refs.flickity.$flickity.x - this.tickerSpeed
        this.$refs.flickity.$flickity.settle(this.$refs.flickity.$flickity.x)
        this.raf = window.requestAnimationFrame(this.frame)
      }
    },
    handlePlayType () {
      if (this.mobile) {
        this.pause()
        this.$refs.flickity.playPlayer()
        this.$refs.flickity.off('dragStart', () => {
          this.pause()
        });
        this.$refs.flickity.off('settle', () => {
          this.play()
        });
      } else {
        this.$refs.flickity.stopPlayer()
        this.play()
        this.$refs.flickity.on('dragStart', () => {
          this.pause()
        });
        this.$refs.flickity.on('settle', () => {
          this.play()
        });
      }
    }
  }
}
</script>

<style scoped>
.flickity-container {
  z-index: 4;
}
</style>